import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/shadcn/form'
import { Slider } from '@/components/shadcn/slider'
import { BaseFieldProps } from './types'

export const SliderField: React.FC<BaseFieldProps> = ({ field, formFieldName, control }) => {
  return (
    <FormField
      control={control}
      name={formFieldName}
      render={({ field: formField }) => (
        <FormItem className="flex flex-1 flex-col">
          <FormLabel>{field.title}</FormLabel>
          <FormControl>
            <div className="space-y-2">
              <Slider
                min={field.minimum || 0}
                max={field.maximum || 100}
                step={1}
                value={[(formField.value as number) || 0]}
                onValueChange={([value]) => formField.onChange(value)}
                disabled={field.readonly}
              />
              <div className="text-right text-sm text-muted-foreground">Value: {formField.value as number}</div>
            </div>
          </FormControl>
          <FormDescription>{field.description}</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
